import "./ProductServiceCard.css";
import "./ProductServiceCardResponsive.css";

import CustomAnchor from "../../shared/Anchor/CustomAnchor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

type ProductServiceCardProps = {
  item: {
    header: string;
    description: string;
    image: string;
    linkText: string;
  };
};

function ProductServiceCard({
  item: { header, description, image, linkText },
}: ProductServiceCardProps) {
  return (
    <div className="col-lg-3 col-md-6 col-sm-6 col-12 product-service-card-wrapper">
      <div className="card">
        <div className="card-header p-0 m-0">
          <img
            src={require(`../../assets/images/products-serv/${image}`)}
            loading="eager"
            alt="product and service header"
            className="header-image"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        <div className="card-body">
          <h1>{header}</h1>
          <p>{description}</p>
        </div>
        <div className="card-footer">
          <CustomAnchor
            path="/about/products-services"
            classname="d-flex gap-2 align-items-center link"
          >
            <span>{linkText}</span>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </CustomAnchor>
        </div>
      </div>
    </div>
  );
}

export default ProductServiceCard;
